module.exports = __webpack_public_path__ + "img/FPT12.2b2b5c4c.svg";